import { render, staticRenderFns } from "./TeamHeader.vue?vue&type=template&id=34973288"
import script from "./TeamHeader.vue?vue&type=script&lang=js"
export * from "./TeamHeader.vue?vue&type=script&lang=js"
import style0 from "./TeamHeader.vue?vue&type=style&index=0&id=34973288&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports